
if($('footer#footer').length){
    $(document).on('click', '.custom-footer>div h4', function(){
        $(this).closest('.custom-footer>div').toggleClass('openIt')
    });

if($('footer#footer .customSocial').length){
$('footer#footer .customSocial').append($('.custom-footer__contact  .contact-box li span.instagram').closest('li'));
$('footer#footer .customSocial').append($('.custom-footer__contact  .contact-box li span.facebook').closest('li'));

}
}